import PriceRowLoyaltyPoints from 'LuxKit/PricePoints/Loyalty/BedbankLoyalty/PriceRowLoyaltyPoints'
import React, { ComponentProps } from 'react'

type InheritedPriceRowLoyaltyPointsProps = Pick<ComponentProps<typeof PriceRowLoyaltyPoints>, 'horizontalAlign' | 'size' | 'bedbankLoyaltyDisplay'>

interface Props extends InheritedPriceRowLoyaltyPointsProps {
  offer?: App.Offer | App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary
}

function _BedbankLoyaltyPointsEarn(props: Props) {
  const {
    offer,
    size = 'S',
    horizontalAlign,
    bedbankLoyaltyDisplay,
  } = props

  // For bedbank offers, use chainName. For hotel offers, use chainId
  const chainInfo = offer?.type === 'bedbank_hotel'
    ? (offer as App.BedbankOfferSummary)?.property.chainName
    : (offer as App.HotelOfferSummary)?.property.chainId

  return <div>
    <PriceRowLoyaltyPoints
      size={size}
      horizontalAlign={horizontalAlign}
      bedbankLoyaltyDisplay={bedbankLoyaltyDisplay}
      chainInfo={chainInfo}
    />
  </div>
}

export default _BedbankLoyaltyPointsEarn
